/**
 * Custom scripts for the Dawn theme
 */


// Initialize scripts when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {



    const AImenu = document.querySelector(".ai-nutritionist");
    const AIcontainer = document.querySelector("div#ai-nutritionist");
    const AImainmenu = document.querySelector("a#ai-nutritionist-menu");
    const AIpopup = document.querySelector("#activate-ai-nutritionist-poup-wrapper");
    const AIclose = document.querySelector("#activate-ai-nutritionist-close");
    const AImobilemenu = document.querySelector("#mobile-ai-nutritionist");
    const AtcBtn = document.querySelector("#custom-add-to-cart");

    if(AtcBtn){
      AtcBtn.addEventListener("click", function (e) {
        e.preventDefault();

        const variantId = AtcBtn.dataset.variant;
        const sellingPlanId = AtcBtn.dataset.sellingPlan;
        const quantity = parseInt(AtcBtn.dataset.quantity) || 1;

        if (!variantId || !sellingPlanId) {
          console.error("Missing variant ID or selling plan ID");
          return;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantity,
            selling_plan: Number(sellingPlanId)
          })
        })
        .then(res => {
          if (!res.ok) throw new Error("Failed to add to cart");
          return res.json();
        })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch(err => console.error(err));
      });
    }
    if (AIclose && AIpopup) {
      AIclose.addEventListener('click', () => {
        AIpopup.classList.remove("active-popup");
      });
    }

    const hasAINav = AImenu || AIcontainer || AImainmenu || AImobilemenu || AIpopup;

    if (hasAINav && window.customer_id) {
    const urlold =
    "https://app.alyvewellness.com/api/proxy_get_recharge_subscription";


    const payloadold = {
      // result_id: backboneId,
      // token: btoa(`gid://shopify/Customer/${window.customer_id}`),
      token: btoa(`${window.customer_id}`),
      customerToken: btoa(`gid://shopify/Customer/${window.customer_id}`),
    };


      fetch(urlold, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-customer-email": window.customer_email,
          "x-customer-id": window.customer_id,
          "x-customer-signature": window.token_hmac,
          "x-shopify-shop-domain": "alyve-store.myshopify.com",
        },
        body: JSON.stringify(payloadold),
      })
      .then((response) => {
        if (!response.ok)
          // throw new Error(`HTTP error! Statussssss: ${response.status}`);
        if(response.status == "404"){
          if(AImenu || AIcontainer || AImainmenu || AImobilemenu || AIpopup){
            AImenu.classList.add("no-subscription");
            AIcontainer.setAttribute("hidden","hidden");
            AImainmenu.classList.add("no-subscription");
            AImainmenu.setAttribute("href","");
            AImobilemenu.classList.add("no-subscription");
            }
        }
        return response.json();
      })
      .then((populatedRecords) => {
            let subscriptions = populatedRecords.data.subscriptions_data || [];
            // Filter only ACTIVE subscriptions
            const activeSubscriptions = subscriptions.filter(
              (sub) => sub.status === "ACTIVE"
            );
            
            // Look for 'AI nutritionist' in ACTIVE ones
            const personalisedSubscription = activeSubscriptions.find((sub) =>
              sub.product_title.toLowerCase().includes("ai nutritionist")
            );
            const personalisedProdSubscription = activeSubscriptions.find((sub) =>
              sub.product_title.toLowerCase().includes("personalised vitamins")
            );
            
            const currentURL = window.location.href;
            // console.log(personalisedSubscription.status,"subscriptions",currentURL,"window.location.href")
            const AIsubscription = personalisedSubscription.status;
            const personalisedsubscriptionstatus = personalisedProdSubscription.status;
            // console.log(AIsubscription,"AIsubscription",personalisedsubscriptionstatus,"personalisedsubscriptionstatus");
            
            if ((AIsubscription === "ACTIVE" || personalisedsubscriptionstatus === "ACTIVE") && currentURL.includes("ai-nutritionist")) {
              AIcontainer.removeAttribute("hidden");
            } else {
              AIcontainer.setAttribute("hidden", "hidden");
            }

            if((personalisedsubscriptionstatus == "ACTIVE" || AIsubscription == "ACTIVE") || currentURL.includes("ai-nutritionist")){
              AIpopup.classList.remove("active-popup");
              AImenu.classList.remove("no-subscription");
              AImainmenu.classList.remove("no-subscription");
              AImainmenu.setAttribute("href","./account#ai-nutritionist");
              AImobilemenu.classList.remove("no-subscription");
            } else {
              AIpopup.classList.add("active-popup");
              AImenu.classList.add("no-subscription");
              AImainmenu.classList.add("no-subscription");
              AImainmenu.setAttribute("href","");
              AImobilemenu.classList.add("no-subscription");
            }
      })
    .catch((error) => {
      console.error("❌ Failed to load subscription:", error.message);
    });
    }

  const noSubscriptionbtn = document.getElementById('ai-nutritionist-menu');
  if (noSubscriptionbtn) {
    noSubscriptionbtn.addEventListener('click', function (event) {
      if (noSubscriptionbtn.classList.contains("no-subscription")) {
        event.preventDefault(); // stop link navigation
        if (AIpopup) {
          AIpopup.classList.add("active-popup");
        }
      }
    });
  }


  const nutritionist = document.querySelectorAll(".mobile-submenu-content > a");
  const accountnav = document.querySelector(".account-nav-wrap");
  const mobilenav = document.querySelector(".mobile-bottom-nav");
  const mobilepanels = document.querySelector(".mobile-submenu-panels");
  const currentURL = window.location.href;

  function customALA() {
    if (!accountnav || !mobilenav || !mobilepanels) return;
    if (currentURL.includes("ai-nutritionist")) {
      if (window.innerWidth <= 989) {
        accountnav.style.display = "none";
        mobilenav.style.display = "none";
        mobilepanels.style.display = "none";
      } else {
        accountnav.style.display = "block";
        mobilenav.style.display = "flex";
        mobilepanels.style.display = "block";
      }
    } else if (window.innerWidth >= 990 || currentURL.includes("ai-nutritionist")) {
      accountnav.style.display = "block";
      mobilenav.style.display = "flex";
      mobilepanels.style.display = "block";
    }
  }

  // Run on load
  customALA();

  // Run on resize
  if (accountnav || mobilenav || mobilepanels) {
    window.addEventListener("resize", customALA);
  }

    nutritionist.forEach(elem => {
      elem.addEventListener('click', () => {
        setTimeout(() => {
          if (!accountnav || !mobilenav || !mobilepanels) return;
          if (elem.getAttribute("href").includes("ai-nutritionist")) {
            accountnav.style.display = "none";
            mobilenav.style.display = "none";
            mobilepanels.style.display = "none";
          } else {
            accountnav.style.display = "block";
            mobilenav.style.display = "flex";
            mobilepanels.style.display = "block";
          }
        },200)
      });
    })


  // Add your initialization code here
  initHoverToClick();
  initSmoothScroll();
  
  // Utility function to make dropdown menus open on hover
  function initHoverToClick() {
    // Target all details in header menus
    const detailsElements = document.querySelectorAll('details[id^="Details-HeaderMenu-"], details[id^="Details-HeaderSubMenu-"]');
    const headerWrapper = document.querySelector('.header-wrapper');
    
    detailsElements.forEach(details => {
      let hoverTimeout;
      let hoverIntentTimeout;
      
      // Open on mouseenter with delay to verify hover intent
      details.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        clearTimeout(hoverIntentTimeout);
        
        // Add hovered class to header-wrapper
        if (headerWrapper) headerWrapper.classList.add('hovered');
        
        // Delay to confirm hover intent before proceeding
        hoverIntentTimeout = setTimeout(() => {
          // Only trigger if not already open
          if (!details.hasAttribute('open')) {
            const summary = details.querySelector('summary');
            if (summary) {
              details.setAttribute('open', '');
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        }, 100); // 300ms delay to confirm hover intent
      });
      
      // Cancel hover intent if mouse leaves before timeout
      details.addEventListener('mouseleave', () => {
        clearTimeout(hoverIntentTimeout);
        
        // Remove hovered class from header-wrapper
        if (headerWrapper) headerWrapper.classList.remove('hovered');
        
        hoverTimeout = setTimeout(() => {
          if (details.hasAttribute('open')) {
            const summary = details.querySelector('summary');
            if (summary) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }
          }
        }, 100); // Delay in ms before closing
      });
      
      // Handle nested menus
      const nestedDetails = details.querySelectorAll('details');
      nestedDetails.forEach(nestedDetail => {
        // Clear parent's timeout when entering nested menu
        nestedDetail.addEventListener('mouseenter', (e) => {
          e.stopPropagation();
          clearTimeout(hoverTimeout);
          
          // Keep hovered class on header-wrapper for nested menus
          if (headerWrapper) headerWrapper.classList.add('hovered');
        });
        
        // For submenu items, we need to prevent them from closing immediately
        nestedDetail.addEventListener('mouseleave', (e) => {
          e.stopPropagation(); // Prevent triggering parent's mouseleave
        });
      });
      
      // Prevent clicks from toggling the menu (let hover handle it instead)
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          return false;
        });
      }
      
      // Handle submenu list items
      const submenuItems = details.querySelectorAll('.header__submenu li');
      submenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout); // Prevent menu from closing when hovering over submenu items
          
          // Keep hovered class on header-wrapper for submenu items
          if (headerWrapper) headerWrapper.classList.add('hovered');
        });
      });
    });
  }

  // Function to enable smooth scrolling for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        
        // Skip if it's just "#" or empty
        if (targetId === '#' || !targetId) return;
        
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          e.preventDefault();
          
          // Get sticky header height to offset scrolling
          const stickyHeader = document.querySelector('.header-wrapper');
          const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
          
          // Calculate the final scroll position with the header offset
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;
          
          // Smooth scroll to element with offset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          // Update URL without reload, for better UX
          history.pushState(null, null, targetId);
        }
      });
    });
  }

});

  // Blood test results page starts //

  const observer = new MutationObserver(() => {
  const bloodTestHeader = document.querySelectorAll(".main-outer-bloodTestBoxHeader");
    bloodTestHeader.forEach(header => {
      if (header.dataset.listenerAdded) return;

      header.addEventListener('click', () => {
        const panel = header.nextElementSibling;
        const wasOpen = panel.classList.contains('active-test-results');

        // 1) Remove header active state from ALL headers
        document
          .querySelectorAll('.main-outer-bloodTestBoxHeader.active-header')
          .forEach(h => h.classList.remove('active-header'));

        // 2) Fade out and close ALL open panels (including the clicked one if open)
        document
          .querySelectorAll('.main-outer-bloodTestBoxContainer.active-test-results')
          .forEach(box => {
            box.style.opacity = 0; // start fade-out
            setTimeout(() => {
              box.classList.remove('active-test-results'); // triggers display:none via CSS
              box.style.opacity = ''; // cleanup inline style
            }, 300); // match your CSS transition
          });

        // 3) If the clicked one was closed, open + fade it in. Otherwise it just closes.
        if (!wasOpen) {
          header.classList.add('active-header');
          panel.classList.add('active-test-results'); // display:block via CSS
          panel.style.opacity = 0;                    // start hidden
          requestAnimationFrame(() => {               // ensure transition applies
            panel.style.opacity = 1;                  // fade in
          });
        }
      });

      header.dataset.listenerAdded = 'true';
    });

  });

  observer.observe(document.body, { childList: true, subtree: true });

    function sortResults(type, order = 'asc') {
      const container = document.getElementById("mainContainerBloodTest");

      // loop through each .main-blood-test-container
      container.querySelectorAll(".main-blood-test-container").forEach(innerContainer => {
        const items = Array.from(innerContainer.querySelectorAll(".main-blood-test-wrapper"));

        const getTimestamp = (el) => {
          if (el.dataset.ts && Number.isFinite(+el.dataset.ts)) return +el.dataset.ts;
          const str = el.dataset.date || '';
          const parsed = Date.parse(str);
          if (!Number.isNaN(parsed)) return parsed;
          const m = str.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/);
          if (m) {
            const d = +m[1], mo = +m[2], y = +m[3];
            const dt = new Date(y, mo - 1, d);
            if (dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d) {
              return dt.getTime();
            }
          }
          return Number.POSITIVE_INFINITY;
        };

        const getTitle = (el) => (el.dataset.title || '').toLowerCase();

        items.sort((a, b) => {
          if (type === 'date') {
            const A = getTimestamp(a), B = getTimestamp(b);
            return order === 'asc' ? A - B : B - A;
          } else {
            const A = getTitle(a), B = getTitle(b);
            if (A < B) return order === 'asc' ? -1 : 1;
            if (A > B) return order === 'asc' ? 1 : -1;
            return 0;
          }
        });

        // put back only into the SAME inner container
        items.forEach(item => innerContainer.appendChild(item));
      });
    }

      function applySortFromSelect(selectEl) {
      if (!selectEl) return;
      const value = selectEl.value;
      const label = (selectEl.options[selectEl.selectedIndex]?.textContent || '')
        .trim()
        .toLowerCase();

      if (label.includes('newest')) {
        sortResults('date', 'desc'); // newest first
        return;
      }
      if (label.includes('oldest')) {
        sortResults('date', 'asc'); // oldest first
        return;
      }
      if (label.includes('a-z') || value === 'alpha-asc') {
        sortResults('alpha', 'asc');
        return;
      }
      if (label.includes('z-a') || value === 'alpha-desc') {
        sortResults('alpha', 'desc');
        return;
      }

      // Semantic fallback if labels change later
      if (value === 'date-desc') sortResults('date', 'desc');
      else if (value === 'date-asc') sortResults('date', 'asc');
    }

    // Attach dropdown change event
     const sortOptions = document.getElementById("sortOptions");
      if (sortOptions) {
        sortOptions.addEventListener("change", (e) => {
          applySortFromSelect(e.target);
        });

        // Re-apply when blood-test cards are injected asynchronously
        let lastItemCount = 0;
        const bloodSortObserver = new MutationObserver(() => {
          const items = document.querySelectorAll(
            '#mainContainerBloodTest .main-blood-test-wrapper'
          );
          if (items.length && items.length !== lastItemCount) {
            lastItemCount = items.length;
            applySortFromSelect(sortOptions);
          }
        });
        const bloodContainer = document.getElementById('mainContainerBloodTest');
        if (bloodContainer) {
          bloodSortObserver.observe(bloodContainer, { childList: true, subtree: true });
        }

        // Default: use selected option (Newest on first load)
        applySortFromSelect(sortOptions);
      }

    // Default sort (optional)
    // sortResults("date", "desc");
  
    const activatePopup = document.querySelector("#blood-test-popup-wrapper");
    const bloodTestPopupClose = document.querySelector("#bloodTestPopupClose");

    if (activatePopup && bloodTestPopupClose) {
      bloodTestPopupClose.addEventListener("click", (e) => {
        activatePopup.classList.remove("active");
      });

      const kitobserver = new MutationObserver(() => {
        const activateButton = document.querySelectorAll(".custom-activate-kit-button");
        activateButton.forEach(actBtn => {
          actBtn.addEventListener("click", (e) => {
            activatePopup.classList.add("active");
          });
        });
      });

      kitobserver.observe(document.body, { childList: true, subtree: true });
    }

  // Blood test results page ends //

  // Cart drawer: hide quantity selector for free (£0 / FREE) line items after discount
  (function () {
    function syncFreeItemQuantitySelectors() {
        document.querySelectorAll('#slidecarthq .item').forEach(function (item) {
              var priceEl = item.querySelector('.price:not(.strike-through)');
                    var qty = item.querySelector('.quantity-selector');
                          if (!priceEl || !qty) return;
                                var priceText = priceEl.textContent.replace(/\s/g, '').toUpperCase();
                                      var isFree = priceText === 'FREE' || priceText === '£0.00' || priceText === '£0';
                                            qty.style.display = isFree ? 'none' : '';
                                                });
                                                  }

                                                    var slideCartJsObserver = new MutationObserver(syncFreeItemQuantitySelectors);
                                                      slideCartJsObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
                                                        document.addEventListener('DOMContentLoaded', syncFreeItemQuantitySelectors);
                                                          syncFreeItemQuantitySelectors();
                                                          })();
                                                          
